
import { Component, Vue, Prop } from "nuxt-property-decorator";
import get from "lodash/get";
import serverErrorImg from "../../../assets/images/error-placeholder.png";

@Component({
  name: "PictureComponent",
})
export default class PictureComponent extends Vue {
  @Prop({ required: true }) image!: string;

  @Prop() webpPath?: string;

  @Prop({ default: "" }) url!: string;

  @Prop() className?: string | Record<string, unknown> | string[];

  @Prop(Boolean) isLazy?: boolean;

  @Prop() title?: string;

  @Prop() alt?: string;

  get defaultUrl(): string {
    const img = get(this.image, this.url, this.image);
    return get(img, "url", img) || get(this.image, "url", this.image);
  }

  get hasWebp(): boolean {
    return !!this.webpPath;
  }

  get webp(): string {
    const img = get(this.image, this.webpPath || "", this.image);
    return typeof img === "string" ? img : (img as Image)?.url;
  }

  errorHandler() {
    if(this.$refs.img) {
      (this.$refs.img as HTMLImageElement).src = serverErrorImg;
      (this.$refs.img as HTMLImageElement).title = "can't load image";
      (this.$refs.img as HTMLImageElement).style.backgroundColor = "#f8f8f8";
    }
    (this.$refs.source as HTMLImageElement)?.remove();
  }
}
